import dataSource from '../../../../utils/AngularGrid/genericDataSource'
import angularGridValueGetters from '../../../../utils/AngularGrid/valueGetters'
import angularGridTemplates from '../../../../utils/AngularGrid/templates'
import partServer from '../../../server/index'
import { filter } from 'lodash'

export class PartPropertyGridController {
  constructor(partServer, $state, userProfile) {
    this.$state = $state

    const defaultQuery = {}
    this.query = { ...defaultQuery }

    this.partServer = partServer
    this.gridOptions = this.getGridOptions(userProfile)

    this.gridOptions.datasource = new dataSource(this.query, this.gridOptions, partServer.partPropertyQuery)
  }

  getGridOptions(userProfile) {
    let columnDefs = [
      { colId: 'name', headerName: 'Part Room', field: 'Name', editable: false, suppressMenu: true },
      { colId: 'property', headerName: 'Property', valueGetter: angularGridValueGetters.byPath('Property.Name'), field: 'PropertyId', editable: false, suppressMenu: true },
      {
        colId: 'edit',
        headerName: '',
        width: 20,
        template: angularGridTemplates.edit('ctrl.editPartProperty(data)'),
        editable: false,
        suppressMenu: true,
        suppressSorting: true,
        requiresPermission: 'partEdit'
      }
    ]

    columnDefs = filter(columnDefs, function (columnDef) {
      var permission = columnDef.requiresPermission
      return permission === undefined || userProfile.hasPermission(permission)
    })

    return {
      enableServerSideSorting: true,
      enableServerSideFilter: true,
      columnDefs,
      enableColResize: true,
      angularCompileRows: true,
      rowHeight: 40
    }
  }

  editPartProperty(data) {
    const { Id: partPropertyId } = data
    this.$state.go('.edit', { partPropertyId })
  }

  filterChanged() {
    this.gridOptions.api.setDatasource(new dataSource(this.query, this.gridOptions, this.partServer.partPropertyQuery))
  }

  clearFilters() {
    this.query = {
      ...this.defaultQuery
    }
    this.filterChanged()
  }
}
PartPropertyGridController.$inject = [partServer.vsName, '$state', 'userProfile']